import {UmpireCurrentTableGroupStats} from '../umpire-current-table-group-stats';
import {UmpireSquad} from '../umpire-squad';

export interface UmpireStandings {
  type: string;

  id: string;

  name: string;

  squads: UmpireSquad[];

  standings: UmpireCurrentTableGroupStats[];
}
